import React from 'react'
import Slider from 'material-ui/Slider'
import FormLabel from 'components/labels/FormLabel'
import { compose, withState, lifecycle, mapProps } from 'recompose'

const FormSlider = compose(
  withState(
    'sliderValue',
    'setSliderValue',
    ({ value, defaultValue }) => defaultValue || value || 0),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      const {
        value: nextValue,
      } = nextProps
      const {
        value: prevValue,
        setSliderValue,
      } = this.props
      if (prevValue !== nextValue) {
        setSliderValue(nextValue)
      }
    },
  }),
  mapProps(({
    value,
    ...otherProps
  }) => ({
    ...otherProps,
  })),
)(
  (props) => {
    const {
      sliderValue,
      setSliderValue,
      onChange,
      min = 0,
      max = 100,
      step = 1,
      renderLabel,
      sliderStyle,
      ...otherProps
    } = props
    return (
      <div>
        {renderLabel && (
          <FormLabel>
            {renderLabel(sliderValue)}
          </FormLabel>
        )}
        <Slider
          sliderStyle={{
            marginTop: 8,
            marginBottom: 24,
            ...sliderStyle,
          }}
          value={sliderValue}
          onDragStop={() => onChange(sliderValue)}
          onChange={(_, val) => setSliderValue(val)}
          min={min}
          max={max}
          step={step}
          {...otherProps}
        />
      </div>
    )
  },
)

FormSlider.propTypes = {
}

FormSlider.defaultProps = {
}

export default FormSlider



// WEBPACK FOOTER //
// ./src/components/forms/FormSlider.js